import React, { createContext, useContext } from 'react';

const DeviceOrderPlanContext = createContext(undefined);

export const DeviceOrderPlanProvider = ({ children, value }) => {
    return <DeviceOrderPlanContext.Provider value={value}>{children}</DeviceOrderPlanContext.Provider>;
};

export const useDeviceOrderPlanContext = () => {
    const context = useContext(DeviceOrderPlanContext);
    if (context === undefined) {
        throw new Error('useDeviceOrderPlanContext 必須在 DeviceOrderPlanProvider 中使用');
    }
    return context;
};
